var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.62236 14.3307L7.87914 15.0739C7.56445 15.3886 7.05557 15.3886 6.74422 15.0739L0.236025 8.56908C-0.0786727 8.25439 -0.0786727 7.74551 0.236025 7.43417L6.74423 0.925964C7.05892 0.611267 7.56779 0.611267 7.87914 0.925964L8.62236 1.66918C8.94041 1.98723 8.93371 2.50614 8.60897 2.81749L4.57483 6.66081L14.1965 6.66081C14.6418 6.66081 15 7.01903 15 7.4643L15 8.5356C15 8.98087 14.6418 9.33909 14.1965 9.33909L4.57483 9.33909L8.60897 13.1824C8.93706 13.4938 8.94376 14.0127 8.62236 14.3307Z","fill":"currentColor"}));
}

IconArrowLeft.defaultProps = {"viewBox":"0 0 15 16","fill":"none"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
